import { useCallback, useEffect, useRef ,useState } from 'react'
import { Spin, ConfigProvider, notification } from 'antd'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/fr'
import 'dayjs/locale/es'
import 'dayjs/locale/it'
import CourtesyPage from './Components/Generic/CourtesyPage'
import './Styles/Font.css'
import './Styles/StandardStyle.css'
import './Styles/DefaultIndex.css'
import './Styles/ImageDetail.css'
import './Styles/Icon.css'
import './Styles/Sider.css'
import './Styles/Sider-Collapsible.css'
import './Styles/Popover.css'
import './Styles/Drawer.css'
import './Styles/Button.css'
import './Styles/Switch.css'
import './Styles/Checkbox.css'
import './Styles/Modal.css'
import './Styles/Pagination.css'
import './Styles/Collapse.css'
import './Styles/Scrollbar.css'
import './Styles/Additionalmenu.css'
import './Styles/Pageheader.css'
import './Styles/Table.css'
import './Styles/DarkTheme.css'
import './Styles/Countbox.css'
import './Styles/Tab.css'
import { saveFilters } from './Slices/Kiosk/TableOptionsSlice'
import { setConfigMode, setConfigModeForMessageEvent, setMultiCompany } from './Slices/Kiosk/ArticleSlice'
import { loadLanguage, switchLanguage } from './Slices/LanguageSlice'
import { populateTableWithArticles } from './Services/Kiosk/ArticleServices'
import { getMultiCompany, getTranslation } from './Services/StartupService'
import {
  ModelKey,
  PostObjGrid,
  PostObjOption,
  PostObjReload,
  Language_IT,
  UseridBKdefault,
  DemoDev,
  OverwriteConfigurationKey,
  ConfigurationForm,
  getProfileKey,
  ProfilesKeys,
} from './Constants/Configuration'
import { ArticleColumn } from './Constants/TableConfiguration'
import {
  isFromIntegration,
  isLocalhost,
  fixWorkSpaceCase,
  renderTranslation,
  handleErrorCatchLog,
  sendMessage,
  retrieveAntdLocale,
} from './Helpers/GenericHelpers'
import { sendIntegrationLogInfo } from './Services/ConfigurationService'
import {
  setBarcodeOptionsValues,
  setFormConfigurationValue,
  setProfileValue,
  setB2BMarketplaceValue,
  saveDefaultConfigurations,
  loadConfiguration,
  saveIntegrationInfo,
  loadActiveTheme,
  setPurchasePriceVisible,
  savePublicWorkspace,
  setUserValue,
  setGDPR,
  setCausaliAmmesse,
  setNegoziContoVendita,
  setNegozioHome,
  setNegoziVicini,
  setNegoziLontani,
  setNegoziEscludere,
  saveProfileWorkspaces,
  isFromMVMode,
  setOmnichannelModule,
  setPimModule,
  setLimitQtyModule,
  setOmnichannelStoreModule,
  setOmnichannelSiteModule,
} from './Slices/ConfigurationSlice'
import { TranslationKeys } from './Constants/TranslationKeys'

import { useAppDispatch, useAppSelector } from './hooks'
import { CLIENT_ROUTES } from './Constants/ClientRoutes'
import requestToken from './Services/TokenService'
import { AuthRequest } from './Interfaces/AuthRequest'
import { setTokenToSessionStorage, clearTokenFromSessionStorage } from './Helpers/TokenHelper'
import { ProfileWorkspaceMapping, getDefaultWorkspace } from 'Constants/WorkSpace'
import { getConfigurationList, rowKeysSet } from 'Helpers/ConfigurationHelper'
import { formatString } from 'Helpers/StringHelpers'
import { setImportedSubRule } from 'Slices/Omnichannel/SubRuleSlice'
import {
  consumeIntegrationSession,
  getOnlyIntegrationToken,
  getPayloadAfterToken,
} from './Services/IntegrationService'


function App() {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const currentLanguage = useAppSelector(state => state.present.language.current)
  const serverConfig = useAppSelector(state => state.present.article.serverConfig)
  const userValue = useAppSelector(state => state.present.configuration.userValue)
  const configWorkspace = useAppSelector(state => state.present.configuration.publicWorkspace)
  const profileWorkspaces = useAppSelector(state => state.present.configuration.profileWorkspaces)
  const profileValue = useAppSelector(state => state.present.configuration.profileValue)

  const [tokenReady, setTokenReady] = useState(false)
  const isUrlIntegration = useRef(
    !isFromIntegration(window) &&
    !!(new URLSearchParams(window.location.search).get('token') ||
       new URLSearchParams(window.location.search).get('utente'))
  )
  const [translationsLoaded, setTranslationsLoaded] = useState(false)
  const [configurationLoadTimeout, setConfigurationLoadTimeout] = useState(false)
  const [logReady, setLogReady] = useState(false)

  const eventListenerMessage = useCallback(
    event => {
      if (!event?.data) return

      const postObj = JSON.parse(event.data)

      if (!postObj) return

      //message import excel
      if (postObj.type && postObj.type === 'EXCEL') {
        dispatch(setImportedSubRule({ ruleId: postObj.ruleId, ruleName: postObj.ruleName }))
      }

      //message Opzioni
      //After send option message to integration we get that with listener
      if (postObj.type && postObj.type === PostObjOption && Object.keys(postObj.values).length !== 0) {
        const config = encodeURIComponent(
          postObj.type && postObj.values && postObj.values.config ? postObj.values.config : null,
        )
        const profile = postObj.type && postObj.values && postObj.values.Profilo ? postObj.values.Profilo : null
        const profileKey = getProfileKey(profile)
        let workspace = postObj.type && postObj.values && postObj.values.Workspace ? postObj.values.Workspace : null

        if (config) {
          dispatch(setConfigModeForMessageEvent(config))
        }

        if (postObj.values.Form) {
          dispatch(setFormConfigurationValue(postObj.values.Form))
          if (postObj.values.Form.toUpperCase() === ConfigurationForm.GRUCCIA) {
            workspace = postObj.values.Form
          }
        }

        if (workspace) {
          //save public workspace always when we get integration data (public workspace var is referred only to integration and not on web)
          dispatch(savePublicWorkspace(fixWorkSpaceCase(workspace)))
        } else {
          const defaultWorkspace = fixWorkSpaceCase(getDefaultWorkspace(profileKey))
          dispatch(savePublicWorkspace(defaultWorkspace))
          //save other enabled workspace for the profile

          dispatch(
            saveProfileWorkspaces(
              ProfileWorkspaceMapping[profileKey].map(x => fixWorkSpaceCase(x)).filter(x => x !== defaultWorkspace),
            ),
          )
        }

        if (profileKey) {
          dispatch(setProfileValue(ProfilesKeys[profileKey]))
        }

        if (postObj.values.GDPR) {
          dispatch(setGDPR(postObj.values.GDPR === 'True'))
        }

        if (postObj.values.OmnichannelModule) {
          dispatch(setOmnichannelModule(postObj.values.OmnichannelModule === 'True'))
        }

        if (postObj.values.PimModule) {
          dispatch(setPimModule(postObj.values.PimModule === 'True'))
        }
        if (postObj.values.LimitQtyModule) {
          dispatch(setLimitQtyModule(postObj.values.LimitQtyModule === 'True'))
        }
        if (postObj.values.OmnichannelStoreModule) {
          dispatch(setOmnichannelStoreModule(postObj.values.OmnichannelStoreModule === 'True'))
        }
        if (postObj.values.OmnichannelSiteModule) {
          dispatch(setOmnichannelSiteModule(postObj.values.OmnichannelSiteModule === 'True'))
        }
        if (postObj.values.Utente) {
          const user = postObj.values.Utente
          const datacomp = {
            isActiveMultiComp: postObj.values.CompanyId,
            listCompanies: [{ id: postObj.values.CompanyId, name: postObj.values.CompanyName }],
          }
          dispatch(setMultiCompany(datacomp))
          const fakeCredential: AuthRequest = {
            username: user,
            password: 'password',
            companyId: postObj.values.CompanyId ? postObj.values.CompanyId : 0,
          }
          requestToken(config, fakeCredential).then(authResponse => {
            setTokenToSessionStorage(authResponse.token)
            setTokenReady(true)
          })
          dispatch(setUserValue(user))
        }

        if (postObj.values.B2B) {
          dispatch(setB2BMarketplaceValue(JSON.parse(postObj.values.B2B.toLowerCase())))
        }

        if (postObj.values.language) {
          dispatch(switchLanguage(postObj.values.language.toUpperCase()))
        }

        if (postObj.values.VisualizzaPrezziDiAcquisto) {
          dispatch(setPurchasePriceVisible(postObj.values.VisualizzaPrezziDiAcquisto))
        }

        //barcode options is sent with options
        dispatch(setBarcodeOptionsValues(postObj.values))

        // Other configurations in place of Kiosk_Options cookie
        if (postObj.values?.CausaliAmmesse) {
          dispatch(setCausaliAmmesse(postObj.values.CausaliAmmesse))
        }

        if (postObj.values?.NegoziContoVendita) {
          dispatch(setNegoziContoVendita(postObj.values.NegoziContoVendita))
        }

        if (postObj.values?.NegozioHome) {
          dispatch(setNegozioHome(postObj.values.NegozioHome))
        }

        if (postObj.values?.NegoziVicini) {
          dispatch(setNegoziVicini(postObj.values.NegoziVicini))
        }

        if (postObj.values?.NegoziLontani) {
          dispatch(setNegoziLontani(postObj.values.NegoziLontani))
        }

        if (postObj.values?.NegoziEscludere) {
          dispatch(setNegoziEscludere(postObj.values.NegoziEscludere))
        }
      }

      if (postObj.mdId) {
        //this variables are read after parameters integration message is sent (see Home.tsx after savePriceList)
        dispatch(saveFilters({ key: ModelKey, value: postObj.mdId }))
        if (postObj.vaId) {
          dispatch(rowKeysSet(postObj.vaId))
        }
        dispatch(populateTableWithArticles())
      } else if (postObj.vaId) {
        dispatch(saveFilters({ key: ArticleColumn.TableKey, value: postObj.vaId }))
        dispatch(rowKeysSet(postObj.vaId))
        dispatch(populateTableWithArticles())
      }

      if (postObj.type && postObj.type === PostObjReload) {
        if (postObj.section && postObj.section === PostObjGrid) {
          dispatch(populateTableWithArticles())
        }
      }
      dispatch(saveIntegrationInfo({ value: event.data }))
      if (event.data.includes('vaId') && event.data.includes('mdId')) {
        dispatch(isFromMVMode(true))
      }
      setLogReady(true)
    },
    [dispatch],
  )

const integrationBootstrapStarted = useRef(false)

const clearIntegrationQueryString = () => {
  window.history.replaceState({}, document.title, window.location.pathname)
}
const getRawQueryParam = (paramName: string): string | null => {
  const query = window.location.search.startsWith('?')
    ? window.location.search.substring(1)
    : window.location.search

  if (!query) return null

  const parts = query.split('&')

  for (const part of parts) {
    const eqIndex = part.indexOf('=')
    if (eqIndex === -1) continue

    const key = part.substring(0, eqIndex)
    const value = part.substring(eqIndex + 1)

    if (key === paramName) {
      return decodeURIComponent(value)
    }
  }

  return null
}

const getInitialConfig = (): string | null => {
  const urlConfig = getRawQueryParam('key')
  if (urlConfig) return encodeURIComponent(urlConfig)

  const localConfig = localStorage.getItem(OverwriteConfigurationKey)
  if (localConfig) return encodeURIComponent(localConfig)

  if (isLocalhost()) return encodeURIComponent(DemoDev)

  return null
}

useEffect(() => {
  let cancelled = false

  const bootstrapIntegration = async () => {

    if (isFromIntegration(window)) {
      window.chrome.webview.addEventListener('message', eventListenerMessage)

      if (!serverConfig) {
        sendMessage({ next: PostObjOption, type: 'Sincro' })
      }

      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const urlUserId = urlParams.get('utente')
    const urlToken = urlParams.get('token')
    const urlCompanyId = urlParams.get('companyId')
    const urlConfig = getRawQueryParam('key')

    if (urlUserId && urlConfig) {
      if (integrationBootstrapStarted.current) return

      integrationBootstrapStarted.current = true

      try {
        clearTokenFromSessionStorage()
        setTokenReady(false)

        const data = await getPayloadAfterToken({
          config: urlConfig,
          user: urlUserId,
          password: 'PASSWORD',
          companyId: urlCompanyId ? Number(urlCompanyId) : 0,
        })

        if (cancelled) return

        console.log('Opzioni recuperate tramite OptionPayload:', data)
        eventListenerMessage({ data: JSON.stringify(data) })

        setTokenReady(true)
        clearIntegrationQueryString()
      } catch (err) {
        console.error('Recupero OptionPayload fallito.', err)
        integrationBootstrapStarted.current = false
        clearTokenFromSessionStorage()
        clearIntegrationQueryString()
        window.location.replace(window.location.pathname)
      }

      return
    }

    if (urlToken) {
      try {
        const data = await consumeIntegrationSession(urlToken)

        if (cancelled) return

        if (data?.values?.Utente) {
          const config = encodeURIComponent(data.values.config ? data.values.config : null)
          await getOnlyIntegrationToken({
            config,
            user: data.values.Utente,
            password: 'password',
            companyId: data.values.CompanyId ? Number(data.values.CompanyId) : 0,
          })
        }

        if (cancelled) return

        console.log('Opzioni recuperate tramite Token:', data)
        eventListenerMessage({ data: JSON.stringify(data) })
        clearIntegrationQueryString()
        setTokenReady(true)
      } catch (err) {
        console.error('Integrazione legacy fallita.', err)
        setTokenReady(true)
      }
    }
  }

  bootstrapIntegration()

  return () => {
    cancelled = true

    if (isFromIntegration(window)) {
      window.chrome.webview.removeEventListener('message', eventListenerMessage)
    }
  }
}, [eventListenerMessage])


  useEffect(() => {
    //when server config is ready, it means we got message from integration and variables are set
    if (!serverConfig) return

    // function to load configuration based on the current workspace
    const loadWorkspaceConfiguration = workspace => {
      const configurations = getConfigurationList(profileValue, workspace, userValue, serverConfig, profileWorkspaces)

      // find the default configuration starting with 'D:', sorted alphabetically
      const defaultConfigSaved = configurations
        ?.filter(cfg => cfg && cfg.toLowerCase().startsWith('d:'))
        .sort((a, b) => a.localeCompare(b))[0]

      const configurationName = defaultConfigSaved || fixWorkSpaceCase(workspace)

      dispatch(
        loadConfiguration({
          configurationName,
          user: userValue,
          serverConfig: serverConfig,
        }),
      )
    }

    // handle integration and configuration loading
    // note: browser mode via IntegrationService (isUrlIntegration) must also use the workspace from the payload, not the plain-browser default
    if (!isFromIntegration(window) && !isUrlIntegration.current) {
      const user = UseridBKdefault

      dispatch(setUserValue(user))
      dispatch(savePublicWorkspace('Backoffice'))
      dispatch(saveProfileWorkspaces('Backoffice'))
      dispatch(saveDefaultConfigurations({ user, serverConfig, publicWorkspace: 'Backoffice' }))

      loadWorkspaceConfiguration('Backoffice')
    } else if (configWorkspace) {
      // serverConfig can become truthy before the integration payload sets configWorkspace; skip until it's known to avoid WorkSpaces[null] crashes
      dispatch(
        saveDefaultConfigurations({
          user: userValue,
          serverConfig: serverConfig,
          publicWorkspace: configWorkspace,
          profileWorkspaces: profileWorkspaces,
        }),
      )

      //load configuration start always after integration data received and current workspace set
      loadWorkspaceConfiguration(configWorkspace)
    }

    dispatch(
      loadActiveTheme({
        user: userValue,
        serverConfig: serverConfig,
      }),
    )

    setTimeout(() => {
      setConfigurationLoadTimeout(true)
    }, 2000)
  }, [dispatch, serverConfig, profileWorkspaces, configWorkspace])

  useEffect(() => {
    document.title = 'Atelier ' + renderTranslation(language, TranslationKeys.titleDiWa)
  }, [language])

  //set picker day/month translations
  useCallback(() => {
    const twoLetterLang = currentLanguage ? currentLanguage : Language_IT

    dayjs.locale(twoLetterLang)
  }, [currentLanguage])

useEffect(() => {
  if (!isFromIntegration(window)) {
    const confToDispatch = getInitialConfig()

    if (confToDispatch) {
      dispatch(setConfigMode(confToDispatch))
    } else {
        console.warn('Config non trovato')
    }
  }
}, [dispatch])

  useEffect(() => {
    if (!isFromIntegration(window) && !isUrlIntegration.current) {
      getMultiCompany()
        .then(data => {
          dispatch(setMultiCompany(data))
        })
        .catch(err => {
          handleErrorCatchLog(err, 'Failed loading MultiCompany getMultiCompany')
        })
    }
    getTranslation()
      .then(data => {
        dispatch(loadLanguage(data))
        setTranslationsLoaded(true)
      })
      .catch(err => {
        handleErrorCatchLog(err, 'Failed loading language translations getTranslation')
      })
  }, [dispatch, currentLanguage])

  useEffect(() => {
    if (isUrlIntegration.current && tokenReady) {
      getMultiCompany()
        .then(data => {
          dispatch(setMultiCompany(data))
        })
        .catch(err => {
          handleErrorCatchLog(err, 'Failed loading MultiCompany getMultiCompany')
        })
    }
  }, [dispatch, tokenReady])

  useEffect(() => {
    if (logReady && tokenReady) {
      dispatch(sendIntegrationLogInfo())
    }
  }, [dispatch, logReady, tokenReady])

  const loading = !(translationsLoaded && (!isFromIntegration(window) || tokenReady) && (!isUrlIntegration.current || tokenReady)) && !configurationLoadTimeout

  const pageReady =
    ((isFromIntegration(window) && tokenReady && configWorkspace) ||
     (!isFromIntegration(window) && (!isUrlIntegration.current || tokenReady))) &&
    serverConfig &&
    translationsLoaded

  const router = createBrowserRouter(CLIENT_ROUTES)

  return (
    <ConfigProvider locale={retrieveAntdLocale(currentLanguage)}>
      <Spin spinning={loading} size='large' style={{ maxHeight: '100%', backgroundColor: 'rgba(0,0,0,0.8)' }}>
        {loading ? (
          <div style={{ minHeight: '100vh', maxHeight: '100%', backgroundColor: 'rgba(0,0,0,0.8)' }}></div>
        ) : pageReady ? (
          <RouterProvider router={router} />
        ) : (
          <CourtesyPage />
        )}
      </Spin>
    </ConfigProvider>
  )
}

export default App
